import { MMButton, SelectAccount } from '@components'
import cn from '@integrations/classnames'
import { useContext } from '@integrations/react'
import { useNavigate } from '@integrations/routing'
import { AccountTypes, paths, useMerchantAccounts } from 'mmfintech-backend-api'
import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'
import { GlobalContext, tr } from 'mmfintech-commons'
import { RequestModalBody, RequestModalSurface, RequestModalTitle } from '../RequestModalSurface'
import styles from './SuggestTransferModal.module.scss'

interface Props {
  account?: AccountBalanceResponse
}

function SuggestTransferModal({ account }: Props) {
  const { modalHide } = useContext(GlobalContext)

  const { activeAccounts } = useMerchantAccounts()

  const selectedAccount =
    account ||
    (Array.isArray(activeAccounts) &&
      activeAccounts.find((a: AccountBalanceResponse) => a?.type === AccountTypes.PRIMARY))
  const navigate = useNavigate()

  return selectedAccount ? (
    <RequestModalSurface className={cn(styles['suggest-transfer-modal-wrapper'], 'suggest-transfer-modal-wrapper')}>
      <div className={cn('suggest-text')}>
        <RequestModalTitle className={cn('title')}>
          {tr('FRONTEND.BANKING.SUGGEST_TRANSFER.TITLE', 'Insufficient balance')}
        </RequestModalTitle>
        <RequestModalBody className={cn('body')}>
          {tr(
            'FRONTEND.BANKING.SUGGEST_TRANSFER.BODY',
            'You have insufficient balance in the selected currency account.'
          )}
        </RequestModalBody>
      </div>

      <div className={cn(styles['suggest-actions'], 'suggest-actions')}>
        <SelectAccount
          staticDisplay
          selectedAccount={selectedAccount}
          label={tr('FRONTEND.BANKING.SUGGEST_TRANSFER.ACCOUNT', 'Account')}
        />
      </div>

      <div className={cn(styles['buttons-container'], 'buttons-container')}>
        <MMButton
          variant='primary'
          caption={tr('FRONTEND.BANKING.SUGGEST_TRANSFER.BUTTON_TRANSFER', 'Transfer between accounts')}
          onClick={() => {
            modalHide()
            navigate(paths.banking.sendIntraAccountTransfer())
          }}
          fullWidth
          data-test='submit-button'
        />
        <MMButton
          variant='secondary'
          caption={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
          onClick={() => modalHide()}
          fullWidth
          data-test='cancel-button'
        />
      </div>
    </RequestModalSurface>
  ) : null
}

export default SuggestTransferModal
